module.exports = __webpack_public_path__ + "img/ic_login_next.5198094b.svg";